import { computed, watch } from 'vue'
import type { Ref } from 'vue'

import type { CaptureVisitInput } from '../types'

import { useRecordVisit } from './useRecordVisit'

export function useBrowsingHistoryCapture({
  kind,
  term,
  landingId,
  productId,
  grade,
  offerType,
}: {
  kind: 'search' | 'plp' | 'pdp'
  term?: Ref<string>
  landingId?: Ref<string | undefined>
  productId?: Ref<string | undefined>
  grade?: Ref<string | undefined>
  offerType?: Ref<string | undefined>
}) {
  const { recordVisit } = useRecordVisit()

  const browsingHistoryPayload = computed<CaptureVisitInput | null>(() => {
    if (kind === 'search') {
      if (!term?.value) return null

      return { kind, term: term.value }
    }

    if (kind === 'plp') {
      if (!landingId?.value) return null

      return { kind, landingId: landingId.value }
    }

    if (!productId?.value || !grade?.value || !offerType?.value) return null

    return {
      kind,
      productId: productId.value,
      grade: grade.value,
      offerType: offerType.value,
    }
  })

  if (import.meta.client) {
    watch(
      browsingHistoryPayload,
      (payload) => {
        if (!payload) return

        void recordVisit(payload)
      },
      { immediate: true },
    )
  }
}
